new Vue({
    delimiters: ['[[', ']]'], // change because vue and django using the same args 
    el: '#app_home',
    data: {
        banners: {
            bandCommuniqueDropdown: false,
        },
        mobile: (window.innerWidth > 991) ? false : true,
        tabletPortrait: (window.innerWidth > 767) ? true : false
    },
    created() {
        window.addEventListener("resize", this.screenHandler);
    },
    mounted() {
        this.secondBlock = true;
    },
    destroyed() {
        window.removeEventListener("resize", this.screenHandler);
    },
    methods: {
        screenHandler() {
            this.mobile = (window.innerWidth > 991) ? false : true;
            this.tabletPortrait = (window.innerWidth > 767) ? true : false;
        }
    }
})

//sliders
$(document).ready(function () {
    var bannerHomeFull = $('.home__banner');

    var optionsBannerHome = {
        arrows: true,
        autoplay: true,
        autoplaySpeed: 8000,
        dots: true,
        //fade: true,
        infinite: true,
        mobileFirst: true,
        adaptiveHeight: true,
        pauseOnHover: true,
        pauseOnFocus: true,
        slidesToShow: 1,
        speed: 1500,
        cssEase: 'cubic-bezier(0.39, 0.58, 0.15, 0.98)',
    }

    // Init banner
    function initBannerHome(el) {
        el.slick(optionsBannerHome);
    }

    bannerHomeFull.on('init', function(event, slick) {
        $('.banner-home').find('.banner-home__loading').hide();
        $('.slider-slick').css({
            visibility: 'visible',
            opacity: '1'
        });
    });

    initBannerHome(bannerHomeFull);

    waitForElementToExist('.home-size').then(element => {
        const item = element.querySelector('.home-size__content');
        if(item && window.outerWidth <= 991) {
            // Pega todos os filhos diretos
            const children = Array.from(item.children);
            
            if (children.length > 0) {
                // Calcula quantos elementos vão em cada div
                const totalChildren = children.length;
                const firstDivCount = Math.ceil(totalChildren / 2);
                const secondDivCount = totalChildren - firstDivCount;
                
                // Cria as duas divs
                const firstDiv = document.createElement('div');
                const secondDiv = document.createElement('div');
                
                // Adiciona classes para identificação
                firstDiv.className = 'home-size__content--left';
                secondDiv.className = 'home-size__content--right';
                
                // Move os elementos para a primeira div
                for (let i = 0; i < firstDivCount; i++) {
                    firstDiv.appendChild(children[i]);
                }
                
                // Move os elementos restantes para a segunda div
                for (let i = firstDivCount; i < totalChildren; i++) {
                    secondDiv.appendChild(children[i]);
                }
                
                // Limpa o conteúdo original e adiciona as duas divs
                item.innerHTML = '';
                item.appendChild(firstDiv);
                item.appendChild(secondDiv);
            }
        }
    });

    waitForElementToExist('.first-banner').then(element => {
        const banner = element.querySelector('#banner-categorias');

        if(banner) {
            $('#banner-categorias').slick({
                arrows: true,
                dots: false,
                infinite: true,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 700,
                autoplay: true,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: "unslick"
                    }
                ]
            });
        }
    });

    waitForElementToExist('.banner-triplo').then(element => {
        const banner = element.querySelector('.banner-triplo__list');

        if(banner) {
            $('.banner-triplo__list').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
        
                responsive: [
                    {
                        breakpoint: 991,
                        settings: "unslick"
                    }
                ]
            });
        }
    });

    waitForElementToExist('.first-vitrine').then(element => {
        const firstCarrousel = element.querySelector('.product_list');
        if(firstCarrousel) {
            $('.product_list').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 700,
        
                responsive: [
                    {
                        breakpoint: 577,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('.product_list').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }

        /* Fix bug with slick on new product render (vitrine) */
        const elementosLazy = document.querySelectorAll('.lazy-img');

        elementosLazy.forEach(elemento => {
        const dataSrc = elemento.getAttribute('data-src');
        if (dataSrc) {
            elemento.setAttribute('src', dataSrc);
            elemento.removeAttribute('data-src');
        }
        });
    });

    waitForElementToExist('.second-vitrine').then(element => {
        const secondCarrousel = element.querySelector('.product_list-2');
        if(secondCarrousel) {
            $('.product_list-2').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 700,
        
                responsive: [
                    {
                        breakpoint: 577,
                        settings: {
                            slidesToShow: 2,
                        }
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 3,
                        }
                    },
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 4,
                        }
                    }
                ]
            });

            $('.product_list').on('afterChange', function(event, slick, currentSlide, nextSlide){
                Blazy({
                    selector: '.lazy-img',
                    successClass: 'loaded-img',
                    success: function(element) {
                        setTimeout(function(){
                            var parent = element.previousSibling;
                            try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
                        }, 200);
                    }
                });
            });
        }

        /* Fix bug with slick on new product render (vitrine) */
        const elementosLazy = document.querySelectorAll('.lazy-img');

        elementosLazy.forEach(elemento => {
        const dataSrc = elemento.getAttribute('data-src');
        if (dataSrc) {
            elemento.setAttribute('src', dataSrc);
            elemento.removeAttribute('data-src');
        }
        });
    });

    waitForElementToExist('.banner-momentos').then(element => {
        const banner = element.querySelector('#banner-momentos');

        if(banner) {
            $('#banner-momentos').slick({
                arrows: true,
                dots: false,
                infinite: false,
                mobileFirst: true,
                slidesToShow: 1,
                slidesToScroll: 1,
                speed: 700,
        
                responsive: [
                    {
                        breakpoint: 991,
                        settings: "unslick"
                    }
                ]
            });
        }
    });

    waitForElementToExist('.faixa-comunicado').then(element => {
        const banner = element.querySelector('#faixa-comunicado');

        if(banner) {
            $('#faixa-comunicado').slick({
                arrows: true,
                dots: false,
                infinite: true,
                mobileFirst: true,
                autoplay: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 700,
        
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: 4,
                            arrows: true,
                        }
                    }
                ]
            });
        }
    });

        waitForElementToExist('.banner-instagram').then(element => {
        const banner = element.querySelector('.banner-instagram__list');

        if(banner) {
            $('.banner-instagram__list').slick({
                arrows: false,
                dots: false,
                infinite: true,
                mobileFirst: true,
                autoplay: true,
                slidesToShow: 2,
                slidesToScroll: 1,
                speed: 700,
        
                responsive: [
                    {
                        breakpoint: 991,
                        settings: "unslick"
                    }
                ]
            });
        }
    });

    waitForElementToExist('.module-faq').then(element => {
        const faqItems = document.querySelectorAll('.faq-item');
        if(faqItems) {
        faqItems.forEach(item => {
            const title = item.querySelector('.faq-item__title');
            const content = item.querySelector('.faq-item__content');
            
            // Inicialmente esconde o conteúdo
            content.style.maxHeight = '0';
            content.style.overflow = 'hidden';
            content.style.transition = 'max-height 0.3s ease-out';
            
            title.addEventListener('click', () => {
                // Fecha todos os outros itens
                faqItems.forEach(otherItem => {
                    if (otherItem !== item) {
                        const otherContent = otherItem.querySelector('.faq-item__content');
                        otherContent.style.maxHeight = '0';
                        otherItem.classList.remove('active');
                    }
                });
                
                // Alterna o item atual
                const isActive = item.classList.contains('active');
                item.classList.toggle('active');
                
                if (isActive) {
                    content.style.maxHeight = '0';
                } else {
                    content.style.maxHeight = content.scrollHeight + 'px';
                }
                });
            });
        }
    });
})